import { Modal, ModalProps } from 'antd';
import dayjs from 'dayjs';

import { css } from '~libs/emotion';
import { TaxInvoiceType } from '~models/tax-invoice';
import PurchaseSettlementPage from '~pages/clobe/purchase-settlement';
import SalesSettlementPage from '~pages/clobe/sales-settlement';

interface Props extends ModalProps {
  settlementType: TaxInvoiceType;
  defaultBusinessEntityId?: number;
}

const defaultStartDate = dayjs().subtract(12, 'M').startOf('month');
const defaultEndDate = dayjs();
const SettlementInfoModal: React.FC<Props> = ({
  settlementType,
  defaultBusinessEntityId,
  ...props
}) => {
  return (
    <Modal
      {...props}
      title={null}
      footer={null}
      width={'90vw'}
      style={{ borderRadius: 8, height: '90vh' }}
      centered
      className={css`
        .ant-modal-content {
          padding: 0;
          border-radius: 8px;
        }
      `}
    >
      <div
        style={{
          background: 'rgb(245, 245, 245)',
          borderRadius: 8,
        }}
      >
        {settlementType === 'PURCHASE' ? (
          <PurchaseSettlementPage
            businessEntityId={defaultBusinessEntityId}
            defaultStartDate={defaultStartDate}
            defaultEndDate={defaultEndDate}
          />
        ) : (
          <SalesSettlementPage
            businessEntityId={defaultBusinessEntityId}
            defaultStartDate={defaultStartDate}
            defaultEndDate={defaultEndDate}
          />
        )}
      </div>
    </Modal>
  );
};

export default SettlementInfoModal;
